import { STORAGE_KEYS } from '../utils/constants';

class StorageService {
  setItem(key, value) {
    try {
      const serializedValue = typeof value === 'string' ? value : JSON.stringify(value);
      localStorage.setItem(key, serializedValue);
    } catch (error) {
      console.error('Error saving to localStorage:', error);
    }
  }

  getItem(key, defaultValue = null) {
    try {
      const item = localStorage.getItem(key);
      if (item === null) return defaultValue;
      
      try {
        return JSON.parse(item);
      } catch {
        return item;
      }
    } catch (error) {
      console.error('Error reading from localStorage:', error);
      return defaultValue;
    }
  }

  removeItem(key) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error('Error removing from localStorage:', error);
    }
  }

  // Application-specific methods
  setLoggedIn(isLoggedIn) {
    this.setItem(STORAGE_KEYS.LOGGED_IN, isLoggedIn);
  }

  isLoggedIn() {
    return this.getItem(STORAGE_KEYS.LOGGED_IN, false);
  }

  setRole(role) {
    this.setItem(STORAGE_KEYS.ROLE_DATA, role);
  }

  getRole() {
    return this.getItem(STORAGE_KEYS.ROLE_DATA);
  }

  setStudentId(studentId) {
    this.setItem(STORAGE_KEYS.STUDENT_ID, studentId);
  }

  getStudentId() {
    return this.getItem(STORAGE_KEYS.STUDENT_ID);
  }

  setLoginId(loginId) {
    this.setItem(STORAGE_KEYS.LOGIN_ID, loginId);
  }

  getLoginId() {
    return this.getItem(STORAGE_KEYS.LOGIN_ID);
  }

  setUserName(name) {
    this.setItem(STORAGE_KEYS.USER_NAME, name);
  }

  getUserName() {
    return this.getItem(STORAGE_KEYS.USER_NAME);
  }

  setUserCode(code) {
    this.setItem(STORAGE_KEYS.USER_CODE, code);
  }

  getUserCode() {
    return this.getItem(STORAGE_KEYS.USER_CODE, '');
  }

  clearUserData() {
    Object.values(STORAGE_KEYS).forEach(key => {
      this.removeItem(key);
    });
  }
}

export const storageService = new StorageService();
export default StorageService;